import { ReactNode } from "react";
import { IUserRolesAccess } from "../../../../routes/routes";
import { TIconShape } from "../../../../types";
import { Role } from "../../../../types/user.type";
import { urls } from "../../../../config/appConfig";

export const sidebarMainItems: SidebarItemProps[] = [
  {
    title: "Portfolio",
    href: "/portfolio",
    icon: "file-badge",
    roles: {
      allowed: [Role.Broker],
      disallowed: [Role.Unverified],
    },
  },
  {
    title: "Insights",
    href: "/risk-and-safety-insights",
    icon: "eye",
    roles: {
      allowed: [Role.Broker],
      disallowed: [Role.Unverified],
    },
  },
  {
    title: "Users",
    href: "/users",
    icon: "people",
    roles: {
      allowed: [Role.Admin, Role.SuperAdmin],
      disallowed: [Role.Unverified],
    },
  },
  {
    title: "Organisations",
    href: "/organisations",
    icon: "organization",
    roles: {
      allowed: [Role.Admin, Role.SuperAdmin],
      disallowed: [Role.Unverified],
    },
  },
  {
    title: "Policies",
    href: "/policies",
    icon: "file-badge",
    roles: {
      allowed: [Role.Broker, Role.Admin, Role.SuperAdmin],
      disallowed: [Role.Unverified],
    },
  },
  {
    title: "Invitations",
    href: "/invitations",
    icon: "mail",
    roles: {
      allowed: [Role.Admin, Role.SuperAdmin],
      disallowed: [Role.Unverified],
    },
  },
  {
    title: "Quotes",
    externalLink: true,
    href: urls.salesforceQuotesUrl,
    icon: "checklist",
    roles: {
      allowed: [Role.Broker],
      disallowed: [Role.Unverified],
    },
  },
  {
    title: "Claims",
    href: "/claims",
    icon: "shield",
    roles: {
      allowed: [Role.Broker, Role.Admin, Role.SuperAdmin],
      disallowed: [Role.Unverified],
    },
  },
  {
    title: "Toolkits",
    href: "/toolkits",
    icon: "tools",
    roles: {
      allowed: [Role.Admin, Role.SuperAdmin],
      disallowed: [Role.Unverified],
    },
  },
  {
    title: "Activity",
    href: "/activity",
    icon: "pulse",
    roles: {
      allowed: [Role.Admin, Role.SuperAdmin, Role.Broker],
      disallowed: [Role.Unverified],
    },
    featureFlag: "portal.activity.all",
  },
  {
    title: "Automations",
    href: "/automations",
    icon: "dependabot",
    roles: {
      allowed: [Role.Admin, Role.SuperAdmin],
      disallowed: [Role.Unverified],
    },
    featureFlag: "portal.automations.create",
  },
  {
    title: "Getting started",
    href: "/get-started",
    icon: "info",
    roles: {
      allowed: [Role.Unverified],
    },
  },
];

export const sidebarFooterItems: SidebarItemProps[] = [
  {
    title: "Log out",
    href: "/logout",
    icon: "sign-out",
  },
  // Profile Link added to footer in Sidebar index
];

export interface SidebarItemProps {
  component?: ReactNode;
  title: string;
  externalLink?: boolean;
  href: string;
  icon: TIconShape;
  roles?: IUserRolesAccess;
  featureFlag?: string;
}
